import moment from 'moment'
import {calculateDate, calculateDateNew} from '../../../../utils'
import {ListInputFieldForm} from '../../../../utils/TypeCommon'
import {ContractModel} from '../../healthInsurance/model/ContractModel'
import {InsurancePlanModel} from '../../healthInsurance/model/InsurancePlanModel'
import {CargoListInsuredModel, CargoOfferFeeModel} from './model/ICargo'
import {MarineListInsuredModel, MarineOfferFeeModel} from './model/IMarine'
import {PropertyLocaModel, PropertyOfferFeeModel} from './model/IProperty'
import {TechnicalListModel, TechnicalOfferFeeModel} from './model/ITechnical'
import {MicroListInsuredModel, MicroOfferFeeModel} from './model/IMicro'

// interface

interface ProductListInsuredModel {
  id: string | null
  ownerCode: string | null
  ownerVersion: string | null
  oldContractCode: string | null
  objectInsuredType: string | null
  certType: string | null
  certNumber: string | null
  price: string | null
  address: string | null
  name: string | null
  yearBuilt: string | null
  floorNumber: string | null
  ownerType: string | null
  houseType: string | null
  businessHouseType: string | null
  fireFighting: string | null
  startDate: string | null
  expireDate: string | null
  packageCode: string | null
  sumFee: number | null
  sumTax: string | null
  validateForm: boolean | null
  listHouse: any
  payeeName: string | null
  payeeNameIdentificationNumber: string | null
  payeesRelationsShip: string | null
  payeePhone: string | null
  payeeEmail: string | null
  packageChoosed: string | null
  listObjectSelected: any
  housePackageBenefitDtos: any
  contractPackageBenefitChecked: any
  fieldInput: ListInputFieldForm
  nationality: string | null
}

export const formProductInsurancePlanState: InsurancePlanModel = {
  businessProgramCode: null,
  productCode: null,
  groupProduct: null,
  exploitingType: null,
  exploitingCode: null,
  typeOfIntroduction: null,
  introductionCode: null,
  curencyMoney: 'VND',
  curencyFee: null,
  exchangeRate: '1',
  exchangeRateNote: null,
  business: null,
  businessName: null,
  currencyFeeChange: null,
  validateForm: null,
  tpa: null,
  tpaType: null,
  tpaFee: null,
  adjacentContractNumberLoss: null,
  adjacentContractNumber: null,
  paymentTimeType: null,
  calculationType: '0',
  nationality: null,
  paymentTimeDay: null,
  packageCodeOriginal: null,
}

export const formTechnicalOfferFeeState: TechnicalOfferFeeModel = {
  id: null,
}
export const formTechnicalListState: TechnicalListModel = {
  id: null,
  listTechnical: [],
  totalRows: null,
}

export const formPropertyOfferFeeState: PropertyOfferFeeModel = {
  id: null,
  packageCode: null,
  addressName: null,
  address: null,
  longitude: null,
  latitude: null,
  subDistrict: null,
  district: null,
  province: null,
  businessAreas: null,
  businessAreasName: null,
  propertyBusinessCode: null,
  propertyBusinessName: null,
  sumBusinessInterruptionInsured: '0',
  sumFireExplosionInsured: '0',
  sumMaterialInsured: '0',
  startDate: moment().format('YYYY/MM/DD'),
  expireDate: calculateDateNew(moment().format('YYYY/MM/DD'), true),
  startActivity: null,
  expireActivity: null,
  startExpireActivity: null,
  riskLevel: null,
  totalPrice: null,
  sumFeeOffer: null,
  sumTaxOffer: null,
  sumFee: null,
  sumTax: null,
  listLocaltion: [],
  totalRows: null,
  validateForm: null,
  callCaculator: null,
  callBenefitDetail: null,
  fieldInputs: [],
  propertyPackageExtensionDto: [],
  _sellingContractPropertyBenefitDtos: [],
  _sellingContractPropertyRiskBenefitDtos: [],
  _sellingContractPropertyExtensionDto: [],
  _sellingContractPropertyDeductibleDto: [],
  _sellingContractPropertyRiskDto: [],
  _sellingContractPropertyBusinessInterruptionDto: [],
}

export const formMicroOfferFeeState: MicroOfferFeeModel = {
  id: null,
  oldContractCode: null,
  sellingContractId: null,
  certType: null,
  objectInsuredType: null,
  certNumber: null,
  name: null,
  code: null,
  address: null,
  characteristic: null,
  nameInsured: null,
  addressInsured: null,
  phoneNumber: null,
  indentifyNumber: null,
  packageCode: null,
  filter: null,
  startDate: moment().format('YYYY/MM/DD'),
  expireDate: calculateDateNew(moment().format('YYYY/MM/DD'), true),
  sellingContractMicroBenefitPackage: [],
  sellingContractMicroExtensionPackage: [],
  sellingContractMicroDeductiblePackage: [],
  sellingContractMicroExtensionFieldPackage: [],
}
export const formMicroInsuredState: MicroListInsuredModel = {
  id: null,
  idObjectMicro: null,
  contractPackageType: null,
  code: null,
  name: null,
  address: null,
  addressInsured: null,
  characteristic: null,
  indentifyNumber: null,
  nameInsured: null,
  phoneNumber: null,
  startDate: null,
  expireDate: null,
  listMicro: [],
  totalRows: null,
  packageChoosed: null,
  listObjectSelected: [],
  _sellingContractMicroBenefitPackage: [],
  _sellingContractMicroDeductiblePackage: [],
  _sellingContractMicroExtensionPackage: [],
  _sellingContractMicroExtensionFieldPackage: [],
}

export const formPropertyLocaInsuredState: PropertyLocaModel = {
  id: null,
  packageCode: null,
  address: null,
  longitude: null,
  latitude: null,
  addressName: null,
  subDistrict: null,
  district: null,
  province: null,
  businessAreas: null,
  businessAreasName: null,
  propertyBusinessCode: null,
  propertyBusinessName: null,
  sumBusinessInterruptionInsured: '0',
  sumFireExplosionInsured: '0',
  sumMaterialInsured: '0',
  startDate: null,
  expireDate: null,
  startActivity: null,
  expireActivity: null,
  riskLevel: null,
  validateForm: null,
  fieldInputs: [],
  listLocaltion: [],
  listContract: [],
  totalRows: null,
  _sellingContractPropertyBenefitDtos: [],
  _sellingContractPropertyDeductibleDto: [],
  _sellingContractPropertyExtensionDto: [],
  _sellingContractPropertyRiskDto: [],
  _sellingContractPropertyBusinessInterruptionDto: [],
}

export const formProductContractState: ContractModel = {
  agency: null,
  contractType: null,
  contractNumber: null,
  originalCode: null,
  created: null,
  purchaseDate: null,
  startDate: null,
  expireDate: null,
  manager: null,
  totalPerson: null,
  sumFee: null,
  partyARepresentative: null,
  partyAPosition: null,
  partyBRepresentative: null,
  partyBPosition: null,
  partyBPhone: null,
  partyAPhone: null,
  partyAPowerOfAttorney: null,
  partyBPowerOfAttorney: null,
  partyBFax: null,
  proxy: null,
  bankCode: null,
  sumTax: null,
  taxType: '1',
  bankNumber: null,
  _sellingContractPaymentScheduleDtos: null,
  _sellingContractExtraDataDtos: null,
  _listContractPackages: null,
  lossRatio: null,
  validateForm: null,
  exploName: null,
  exploManager: null,
  exploitingType: null,
  tsIncharge: null,
  pmIncharge: null,
  paymentTimeType:null,
  commission: '0',
  adminFee: '0',
  vatAdminFee: null,
  endorStartDate: null,
  endorExpireDate: null,
  endorNote: null,
  userReceiveMail: null,
  customerConfirmDate: null,
  dateMoF: null
}

export const formProductHouseInsuredState: ProductListInsuredModel = {
  id: null,
  certType: null,
  certNumber: null,
  ownerCode: null,
  ownerVersion: null,
  oldContractCode: null,
  objectInsuredType: null,
  yearBuilt: null,
  address: null,
  floorNumber: null,
  price: null,
  name: null,
  ownerType: null,
  startDate: moment().format('YYYY/MM/DD'),
  expireDate: calculateDate(moment().format('YYYY/MM/DD'), true),
  houseType: null,
  businessHouseType: null,
  fireFighting: null,
  packageCode: null,
  sumFee: null,
  sumTax: null,
  validateForm: null,
  listHouse: null,
  payeeName: null,
  payeeNameIdentificationNumber: null,
  payeesRelationsShip: null,
  payeePhone: null,
  payeeEmail: null,
  fieldInput: [],
  packageChoosed: null,
  listObjectSelected: null,
  housePackageBenefitDtos: [],
  contractPackageBenefitChecked: null,
  nationality: null,
}

export const formCargoOfferFeeState: CargoOfferFeeModel = {
  id: null,
  packageCode: null,
  code: null,
  ecargoType: null,
  contractPackageType: null,
  packageName: null,
  startDate: null,
  expireDate: null,
  additionalContract: null,
  billOfLading: null,
  inspectionCompany: null,
  transShipment: null,
  shippingType: null,
  commodityGroup: null,
  commodityType: null,
  commodityName: null,
  packingType: null,
  distance: null,
  manufacturingYear: null,
  unit: null,
  weightOrQuantity: null,
  price: null,
  sumFeeCargo: '0',
  sumInsuredFee: '0',
  tripNumber: null,
  imoShip: null,
  note: null,
  lossRatio: null,
  sumFee: null,
  sumTax: null,
  from: null,
  portFrom: null,
  to: null,
  portTo: null,
  nameTransportation: null,
  letterCredit: null,
  invoiceNo: null,
  validateForm: null,
  updateFormStatus: null,
  fieldInput: [],
  contractPackageBenefitChecked: null,
  contractPackageExtensionChecked: null,
  _sellingContractCargoPackageBenefits: [],
  _sellingContractCargoPackageExtraFee: [],
  _sellingContractCargoPackageExtensions: [],
  _sellingContractCargoPackageDeductibles: [],
}

export const formCargoListInsuredState: CargoListInsuredModel = {
  id: null,
  packageCode: null,
  code: null,
  ecargoType: null,
  contractPackageType: null,
  packageName: null,
  startDate: null,
  expireDate: null,
  additionalContract: null,
  billOfLading: null,
  inspectionCompany: null,
  transShipment: null,
  shippingType: null,
  commodityGroup: null,
  commodityType: null,
  commodityName: null,
  packingType: null,
  distance: null,
  manufacturingYear: null,
  unit: null,
  weightOrQuantity: null,
  price: null,
  sumFeeCargo: '0',
  sumInsuredFee: '0',
  tripNumber: null,
  imoShip: null,
  note: null,
  lossRatio: null,
  sumFee: null,
  sumTax: null,
  from: null,
  portFrom: null,
  to: null,
  portTo: null,
  nameTransportation: null,
  letterCredit: null,
  invoiceNo: null,
  validateForm: null,
  updateFormStatus: false,
  _sellingContractCargoPackageBenefits: [],
  _sellingContractCargoPackageExtraFee: [],
  _sellingContractCargoPackageExtensions: [],
  _sellingContractCargoPackageDeductibles: [],
}

export const formMarineOfferFeeState: MarineOfferFeeModel = {
  id: null,
  shipOwner: null, // Tên chủ tàu
  code: null, // Mã gói bảo hiểm được tạo
  name: null, // Tên gói bảo hiểm
  address: null, // địa chỉ (k bat buoc)
  shipGroup: null, // nhóm tàu
  shipType: null, // loại tàu
  manufacturingYear: null, // năm sản xuất
  shipbuildingSite: null, // nơi đóng tàu (k bat buoc)
  pricingType: null, // Kiểu tính phí (k bat buoc)
  tradingLimit: null, // Phạm vi hoạt động (k bat buoc)
  deadweightTonnage: null, // Trọng tải (k bat buoc)
  engineCapacity: null, // Công suất (k bat buoc)
  seat: '1', // số ghế
  startDate: moment().format('YYYY/MM/DD'),
  expireDate: calculateDateNew(moment().format('YYYY/MM/DD'), false),
  price: null, // giá trị tàu
  amountShip: '1', // Số lượng tàu
  material: null, // Vật liệu
  packageCode: null, //Mã Gói bảo hiểm gốc
  grossTonnage: null, //Dung tích tàu
  numberOfCrew: '1', // Số lượng thuyền viên
  shipName: null, // Tên tàu
  imoShip: null, // Số imo
  callSign: null, // Hô hiệu
  shipLevel: null, // Cấp tàu
  pandiClub: null, // Hội P&I
  pandiClubType: null, // Loại phí hội
  pandiClubFee: null, // Phí hội
  pandiClubRate: null, // % phí hội
  priceShipShell: null, // % Giá trị vỏ
  priceEquipment: null, // % Giá trị thiết bị
  priceEngine: null, // % Giá trị máy
  shipRegistrationPort: null, // Cảng đăng kí
  sumFee: null, // Phí
  sumTax: null, // Thuế
  sumFeeOffer: null, // Phí đề xuất
  sumTaxOffer: null, // Thuế đề xuất
  _sellingContractMarinePackageBenefitDtos: [],
  _sellingContractMarinePackageExtensionDtos: [],
  _sellingContractMarinePackageDeductibleDtos: [],
}

export const formMarineInsuredState: MarineListInsuredModel = {
  id: null,
  code: null,
  startDate: null,
  expireDate: null,
  shipOwner: null,
  shipName: null,
  shipGroup: null,
  shipType: null,
  manufacturingYear: null,
  shipbuildingSite: null,
  shipRegistrationPort: null,
  deadweightTonnage: null,
  engineCapacity: null,
  seat: null,
  tradingLimit: null,
  nationality: null,
  imoShip: null,
  shipLevel: null,
  callSign: null,
  pandiClub: null,
  pandiClubType: null,
  pandiClubFee: null,
  pandiClubRate: null,
  priceShipShell: null,
  priceEquipment: null,
  priceEngine: null,
  pricingType: null,
  amountShip: null,
  material: null,
  price: null,
  sumFee: null,
  sumTax: null,
  totalFee: null,
  listMarine: null,
  totalRows: null,
  note: null,
  oldContractCode: null,
  validateForm: null,
  grossTonnage: null,
  numberOfCrew: null,
  _sellingContractMarineBenefitDtos: null,
  _sellingContractMarineExtensionDtos: null,
  _sellingContractMarineDeductibleDtos: null,
}

export interface ProductInitialStateModel {
  tabName?: string
  sellingContractId?: string
  customerCode?: string
  customerVersion?: number
  groupDomainCode?: string
  contractType?: number
  contractKind?: number
  originalContract?: string
  packageExtension?: any
  packageInsurance?: any
  packageTemplate?: any
  form: {
    activeForm: number
    formStatus: number | null
    cleanFormStatus: boolean | null
    formData: {
      formProductInsurancePlan?: InsurancePlanModel
      formProductHouseInsured?: ProductListInsuredModel
      formPropertyOfferFee?: PropertyOfferFeeModel
      formPropertyLocation?: PropertyLocaModel
      formCargoOfferFee?: CargoOfferFeeModel
      formCargoListInsured?: CargoListInsuredModel
      formMarineOfferFee?: MarineOfferFeeModel
      formMarineListInsured?: MarineListInsuredModel
      formTechnicalList?: TechnicalListModel
      formTechnicalOfferFee?: TechnicalOfferFeeModel
      formProductContract?: ContractModel
      formMicroOfferFee?: MicroOfferFeeModel
      formMicroListInsured?: MicroListInsuredModel
    }
  }
}

export interface ListProductInitialStateModel extends Array<ProductInitialStateModel> {}

export const productInitialState: ListProductInitialStateModel = [
  {
    tabName: undefined,
    sellingContractId: undefined,
    customerCode: undefined,
    customerVersion: undefined,
    groupDomainCode: undefined,
    contractType: undefined,
    contractKind: undefined,
    originalContract: undefined,
    packageExtension: undefined,
    packageInsurance: undefined,
    packageTemplate: undefined,
    form: {
      activeForm: 1,
      formStatus: null,
      cleanFormStatus: false,
      formData: {
        formProductInsurancePlan: formProductInsurancePlanState,
        formProductHouseInsured: undefined,
        formPropertyLocation: undefined,
        formPropertyOfferFee: undefined,
        formCargoOfferFee: undefined,
        formCargoListInsured: undefined,
        formMarineOfferFee: undefined,
        formMarineListInsured: undefined,
        formTechnicalList: undefined,
        formTechnicalOfferFee: undefined,
        formProductContract: formProductContractState,
        formMicroOfferFee: undefined,
      },
    },
  },
]
